import {plain, xhrJson} from '@mapsight/ui/config/feature-sources';

import {navPosition} from '../routing/nav-pos';


export const KINDER_POI_URI = 'kinder-poi';

export default function configFeatureSources(magic, locPathName, locState) {
	const navPos = locPathName ? navPosition(magic, locPathName, locState) : {};
	const sources = {};

	if (navPos.app) {
		sources[`${navPos.app.uri}-route`] = xhrJson(`${navPos.app.url}/route/${navPos.app.uri}.geojson`);

		if(navPos.app.uri === 'kinder-de') {
			sources[KINDER_POI_URI] = xhrJson(`${navPos.app.url}/geojson/${KINDER_POI_URI}.geojson`);
		}

		sources[navPos.app.uri] = xhrJson(`${navPos.app.url}/geojson/${navPos.app.uri}.geojson`);
	} else {
		console.warn('Got no App. You\'ll see nothing.', {magic, locPathName});
	}

	Object.assign(sources, {
		userGeolocation: plain(),
		//	searchResult: plain(),
	});

	if (process.env.NN_JS_LOG_LEVEL === 'verbose') {
		console.log('config_feature_sources', {magic, locPathName, sources});
	}
	return sources;
}
